import { CustomNode } from './CustomNode'
import { AccountsList } from './AccountsList'
import { AccountCategoryList } from './AccountCategoryList'
import { PersonsList } from './PersonsList'
import { ThingsList } from './ThingsList'

export const nodeTypeListMap = {
  custom: {
    component: CustomNode,
    label: 'Custom Node'
  },
  account: {
    component: AccountsList,
    label: 'Account'
  },
  accountCategory: {
    component: AccountCategoryList,
    label: 'Account Category'
  },
  person: {
    component: PersonsList,
    label: 'Person'
  },
  thing: {
    component: ThingsList,
    label: 'Thing'
  }
}
